import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Badge, Col, Row,
ModalBody, Modal, ModalFooter, ModalHeader, Button
} from 'reactstrap';
import { AddFileAttempt_ACTION, AddObjectAttempt_ACTION, GetListAttempt_ACTION, GetMultipleListAttempt_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import ModalComponent from './ModalComponent';
import ImageTreeNode from './ImageTreeNode';
import {Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle} from 'react-shapes';
import Slider from '@material-ui/core/Slider';
import NameComponent from './NameComponent';
import { FixURL, responsiveHeight } from '../Services/Utilities';
import ReactCSSTransitionGroup from 'react-transition-group'; // ES6
import Tada from 'react-reveal/Tada';
import ChartModalSliders from '../CanvasDrawing/ChartModalSliders';

var FadingTime;

class ClickableQuestionPlayComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
            ShowImageModal: false,
            ShowChartModal: false,
            SelectedImage:{},
            SelectedChart: {},
            AnswersImage: [],
            AnswersChart: [],
            SlidersValues:[190,0,-190],
            Id: -1,
            RefWidth:0,
            Spy:1,
            StartTime: 0

        }

        this.ImageModal = this.ImageModal.bind(this)
        this.ChartModal = this.ChartModal.bind(this)
        this.calculateChartFromSliders = this.calculateChartFromSliders.bind(this)

    }

    componentDidMount(){
        this.setState({
            Id: this.props.Id
        })

        this.props.GetInfo(this.props.Id)
        setTimeout(() => {
            /*this.setState({
                Spy: this.state.Spy + 1
            }) */
        }, 1000)

        setInterval(() => {
            /*this.setState({
                Spy: this.state.Spy + 1
            })*/
        }, 5000)
    }

  

    componentWillReceiveProps(nextprops){
        if(nextprops.InSeries && nextprops.Question && nextprops.Question.Question && nextprops.Id == this.state.Id){

            if(this.props.Object){
                this.props.Object.setState(prev => ({
                    LoadedClickableQuestions:  [...prev.LoadedClickableQuestions, nextprops.Question.Question]
                }))
            }
            

            this.setState({
                AnswersImage: nextprops.Question.Question.ClickImages.map((i) => {}),
                AnswersChart: nextprops.Question.Question.ClickCharts.map((i) => {}),
                Id: nextprops.Question.Question.Id
            })

            

        }

        if(nextprops.Id != this.state.Id){
            this.props.GetInfo(nextprops.Id)

            this.setState({
                RefWidth:0,
                Id: nextprops.Id,
                ShowImageModal: false,
                ShowChartModal: false,
                SelectedImage:{},
                SelectedChart: {},
                AnswersImage: [],
                AnswersChart: [],
                AnswerStatesCharts:[],
                AnswerStatesImages:[],
                SlidersValues:[190,0,-190],
                ShowAnswer:false,
                ShowSolution: false,
                SelectedChartIndex:null,
                SelectedImageIndex:null,
                StartTime: (new Date()).getTime()
            })

            
        }
    }
    
    render(){
        let RefWidth = this.state.RefWidth * 0.9
        let ShowSolutions = true 
        if(this.props.Map){
            ShowSolutions = this.props.Map.ShowSolutions
        }

        return(
            <div>
                {this.ImageModal()}
                {this.ChartModal()}
              {(this.props.IsQuestionSearching  || this.props.IsQuestionSearching == undefined || this.props.GetQuestionError || this.props.GetQuestionError == undefined) ? 
                      <SearchingTitleComponent error = {this.props.GetQuestionError}/>
                  : <div
                  ref = {'Container_Div'}

                  >
                      <Row
                                                    ref = {'Container_Row'}

                      >
                        <Col xs = {6} style = {{border:0, borderColor:'green', borderStyle:'solid'}}
                                id = "Container_Col"
                              ref = {'Container_Col'}

                        >
                            <div>
                            <img 
                                  style = {{
                                      backgroundPosition:'center',
                                      backgroundRepeat:'no-repeat',
                                      backgroundSize:'contain',
                                      height:(this.props.Question.Question.BackgroundImageHeight/this.props.Question.Question.BackgroundImageWidth)*RefWidth,
                                      width:RefWidth,//(this.props.Question.Question.BackgroundImageWidth),
                                      border:1,
                                      borderColor:'#b3b3b3',
                                      borderStyle:'dashed'
                                  }} 
  
                                  src = {this.props.Question.Question.BackgroundImageURL}
                                  ref = {'Image_Div'}
                                  onLoad = {(Image) => {
                                      Image.persist()

                                      //ERROR
                                      var BaseDiv = ReactDOM.findDOMNode(this.props.BaseDiv)
                                      .getBoundingClientRect()
  
                                      var ImageDiv = ReactDOM.findDOMNode(this.refs['Image_Div'])
                                      .getBoundingClientRect()

                                        var Container_Div =  ReactDOM.findDOMNode(this.refs['Container_Div'])

                                      this.setState({
                                          ImageX: ImageDiv.x,
                                          ImageY:  ImageDiv.y,
                                          BaseY: BaseDiv.y,
                                          RefWidth: Container_Div.children[0].childNodes[0].clientWidth
                                      })
                                  }}

                             />
                             {this.props.Question.Question.ClickImages.map((p, index) => (
                                 <Tada spy = {!this.state.AnswersImage[index] ? this.state.Spy : 0}>
                          <span className="border border-primary" key = {index}
                            style = {{
                              position: 'absolute',
                              cursor:'pointer',
                              width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                              height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                              left: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.X,
                              top:  ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Y,
                              [!this.state.AnswersImage[index] ? "opacity" : ""]: this.state.opacity,
                              backgroundPosition:'center',
                              backgroundRepeat:'no-repeat',
                              backgroundSize:'cover',
                              [p.Background_ImageId ? "backgroundImage" : ""]: p.Background_ImageId ? "url(" + FixURL(p.Background_Image.URL) + ")" : "",
                            }}

                            onClick = {() => {

                                if(this.state.ShowAnswer){
                                    return
                                }

                                this.setState({
                                    ShowImageModal: true,
                                    SelectedImage: p,
                                    SelectedImageIndex: index,
                                    FLImageAnswer: null,
                                    SLImageAnswer: null
                                })
                            }}
                          >
                            <Row style = {{alignItems:'center', justifyContent:'center', display:'flex'}} >
                              {this.state.AnswersImage[index] ? 
                                <img 
                                src = {this.state.AnswersImage[index].URL}
                                style = {{
                                    width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                                    height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                                  
                                    }}
                                />
                                : <div style = {{flexDirection:'column', alignContent:'center', alignItems:'center'}}>
                                    <h1 style={{color:'#b3b300', textAlign:'center'}}>?</h1>
                                  </div>
                                    }
                            </Row>
                           
                            
                          </span>
                          </Tada>
                        ))}
                        {this.props.Question.Question.ClickCharts.map((p, index) => (
                          <Tada spy = {!(this.state.AnswersChart[index] && this.state.AnswersChart[index].Id)? this.state.Spy : 0}>
                          <span key = {index}
                            style = {{
                              position: 'absolute',
                              width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                              height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                              left: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.X,
                              top:  ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Y,
                              backgroundPosition:'center',
                              backgroundRepeat:'no-repeat',
                              backgroundSize:'cover',
                              [p.Background_ImageId ? "backgroundImage" : ""]: p.Background_ImageId ? "url(" + FixURL(p.Background_Image.URL) + ")" : "",
                              cursor:'pointer',
                              border:1, 
                              borderColor:'green',
                              borderStyle:'dashed'
                            }}

                            onClick = {() => {
                                if(this.state.ShowAnswer){
                                    return
                                }

                                this.setState({
                                    ShowChartModal: true,
                                    SelectedChart: p,
                                    SelectedChartIndex: index
                                })
                            }}
                          >
                            
                            <Row style = {{alignItems:'center', justifyContent:'center', display:'flex'}} >
                              {(this.state.AnswersChart[index] && this.state.AnswersChart[index].Id) ? 
                                <img 
                                src = {this.state.AnswersChart[index].URL}
                                style = {{
                                    width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                                    height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                                   
                                }}
                                />
                                : <div style = {{flexDirection:'column', alignContent:'center', alignItems:'center'}}>
                                <h1 style={{color:'#b3b300', textAlign:'center'}}>?</h1>
                              </div>}
                                {(this.state.AnswersChart[index] && !this.state.AnswersChart[index].Id) ? 
                                <h4>
                                    {this.state.AnswersChart[index].AnswerText}
                                </h4>
                                : <div/>}
                            </Row>
                          </span>
                          </Tada>
                        ))}
                        {this.state.ShowAnswer ? this.props.Question.Question.ClickImages.map((p, index) => (
                          <span key = {index}
                            style = {{
                              position: 'absolute',
                              width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                              height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                              left: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.X,
                              top:  ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Y,
                            
                            }}
                          >
                             <div style = {{ flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center', width:'100%'}}>
                                <h1 style = {{color:this.state.AnswerStatesImages[index] ? 'green' : 'red', textAlign:'center', alignSelf:'center',  width:'101%', borderRadius:20}}>
                                    {this.state.AnswerStatesImages[index] ? "✔️" : "❌"}
                                </h1>
                            </div>
                                                
                          </span>
                        )): <div/>}

                        {this.state.ShowAnswer ?  this.props.Question.Question.ClickCharts.map((p, index) => (
                          <span className="border border-success" key = {index}
                            style = {{
                              position: 'absolute',
                              width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                              height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                              left: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.X,
                              top:  ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Y,
                              
                            }}

                            
                          >
                             <div style = {{ flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center', width:'100%'}}>
                                <h1 style = {{color:this.state.AnswerStatesCharts[index] ? 'green' : 'red', textAlign:'center', alignSelf:'center',  width:'101%', borderRadius:20}}>
                                    {this.state.AnswerStatesCharts[index] ? '✔️' : '✖'}
                                </h1>
                            </div>
                            
                          </span>
                        )) : <div/>}
                            </div>
                            </Col>
                           {this.state.ShowSolution ? 
                           <Col xs = {5}>
                                               <img 
                                                   style = {{
                                                       backgroundPosition:'center',
                                                       backgroundRepeat:'no-repeat',
                                                       backgroundSize:'contain',
                                                       height:(this.props.Question.Question.BackgroundImageHeight/this.props.Question.Question.BackgroundImageWidth)* RefWidth,
                                                       width: RefWidth,//(this.props.Question.Question.BackgroundImageWidth),
                                                          border:2,
                                                       borderColor:'green',
                                                       borderStyle:'dashed'
                                                   }} 
                   
                                                   src = {this.props.Question.Question.BackgroundImageURL}
                                                   ref = {'Image2_Div'}
                                                   
                                               />
                                                {this.props.Question.Question.ClickImages.map((p, index) => (
                                                <span className="border border-primary" key = {index}
                                                    style = {{
                                                    position: 'absolute',
                                                    width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                                                    height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                                                    left: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.X,
                                                    top:  ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Y,
                                                   }}

                                                    
                                                >
                                                    <Row style = {{alignItems:'center', justifyContent:'center', display:'flex'}} >
                                                    <img 
                                                        src = {p.Answer.URL}
                                                        style = {{
                                                            width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                                                            height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                                                            left: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.X,
                                                            top:  ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Y,
                                                          
                                                            }}
                                                        />
                                                    </Row>
                                                
                                                    
                                                </span>
                                                ))}
                                                {this.props.Question.Question.ClickCharts.map((p, index) => (
                                                <span  key = {index}
                                                    style = {{
                                                    position: 'absolute',
                                                    width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                                                    height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                                                    left: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.X,
                                                    top:  ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Y,
                                                    backgroundPosition:'center',
                              
                                                    border:1, 
                                                    borderColor:'green',
                                                    borderStyle:'dashed', //-this.state.BaseY  + this.state.ImageY +
                                                    }}

                                                >
                                                    
                                                    <Row style = {{alignItems:'center', justifyContent:'center', display:'flex'}} >
                                                        <img 
                                                        src = {p.Answer.URL}
                                                        style = {{
                                                            width: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)* p.Width,
                                                            height: ((RefWidth)/this.props.Question.Question.BackgroundImageWidth)*p.Height,
                                                           
                                                            }}
                                                        />
                                                    </Row>
                                                </span>
                                                ))}
                                           </Col> : <Col/>}
                                           </Row>
                      
                      
                        
                    
                    
                    
                        
                        <hr/>
                        <Row>
                            {!this.state.ShowAnswer ? 
                                <Col xs = {2}>
                                <h3>
                                    <Badge color = {(
                                        
                                        this.props.Question.Question.ClickImages.length && ( this.state.AnswersImage.filter(a => (a && a.Id)).length != this.props.Question.Question.ClickImages.length)
                                       ||
                                       this.props.Question.Question.ClickCharts.length&&(this.state.AnswersChart.filter(a => (a && a.Id)).length != this.props.Question.Question.ClickCharts.length)
                                      
                                    ) ? 'secondary' : 'success'}
                                    style = {{cursor:'pointer'}}
                                    onClick = {() => {
                                    
                                        

                                        
                                       if((
                                            this.props.Question.Question.ClickImages.length && ( this.state.AnswersImage.filter(a => (a && a.Id)).length != this.props.Question.Question.ClickImages.length)
                                            ||
                                            this.props.Question.Question.ClickCharts.length&&(this.state.AnswersChart.filter(a => (a && a.Id)).length != this.props.Question.Question.ClickCharts.length)
                                              
                                        )){
                                            return
                                        }

                                        this.setState({
                                            ShowAnswer: true,
                                            AnswerStatesImages: this.state.AnswersImage.map((a,i) => {
                                                return( a && (this.props.Question.Question.ClickImages[i].AnswerId == a.Id))
                                            }),
                                            AnswerStatesCharts: this.state.AnswersChart.map((a,i) => {
                                                return( a && (this.props.Question.Question.ClickCharts[i].AnswerId == a.Id))
                                            }),
                                        })

                                       if(this.props.Object){
                                        let QuestionsAnswers = this.props.Object.state.QuestionsAnswers
                                        let QuestionsAnswersFull = this.props.Object.state.QuestionsAnswersFull
                                        
                                        let Correct  =(
                                            !this.props.Question.Question.ClickImages.length ||
                                            this.state.AnswersImage.map((a,i) => {
                                            return( a && (this.props.Question.Question.ClickImages[i].AnswerId == a.Id))
                                            }).every((an) => an == true) )
                                            &&
    
                                            (!this.props.Question.Question.ClickCharts.length || this.state.AnswersChart.map((a,i) => {
                                                return( a && (this.props.Question.Question.ClickCharts[i].AnswerId == a.Id))
                                            }).every((an) => an == true))

                                        QuestionsAnswers[this.props.Object.state.CurrentIndex] = {
                                            Id:  this.props.Question.Question.Id,
                                            Answered: true,
                                            Correct: Correct,
                                            Score: 
                                            this.state.AnswersImage.map((a,i) => {
                                                return( a && (this.props.Question.Question.ClickImages[i].AnswerId == a.Id))
                                            }).filter(a => a).length
                                            + 
                                            this.state.AnswersChart.map((a,i) => {
                                                return( a && (this.props.Question.Question.ClickCharts[i].AnswerId == a.Id))
                                            }).filter(a => a).length + '/ ' + (this.state.AnswersImage.length + this.state.AnswersChart.length)
                                        }

                                        QuestionsAnswersFull[this.props.Object.state.CurrentIndex] = ({
                                            ClickImages:   this.state.AnswersImage.map((a, i) => ({
                                                Id: a.Id,
                                                Image: a.URL,
                                                Width: this.props.Question.Question.ClickImages[i].Width,
                                                Height: this.props.Question.Question.ClickImages[i].Height,
                                                X: this.props.Question.Question.ClickImages[i].X,
                                                Y: this.props.Question.Question.ClickImages[i].Y,

                                            })),

                                            ClickCharts: this.state.AnswersChart.map((a, i) => ({
                                                Id: a.Id,
                                                Image: a.URL,
                                                Width: this.props.Question.Question.ClickCharts[i].Width,
                                                Height: this.props.Question.Question.ClickCharts[i].Height,
                                                X: this.props.Question.Question.ClickCharts[i].X,
                                                Y: this.props.Question.Question.ClickCharts[i].Y,
                                            })),
                                           
                                        })


                                        this.props.Object.setState({
                                            QuestionsAnswers:QuestionsAnswers,
                                            QuestionsAnswersFull: QuestionsAnswersFull
                                        })
                                       }
                                       
                                       let Correct  =(
                                        !this.props.Question.Question.ClickImages.length ||
                                        this.state.AnswersImage.map((a,i) => {
                                        return( a && (this.props.Question.Question.ClickImages[i].AnswerId == a.Id))
                                        }).every((an) => an == true) )
                                        &&

                                        (!this.props.Question.Question.ClickCharts.length || this.state.AnswersChart.map((a,i) => {
                                            return( a && (this.props.Question.Question.ClickCharts[i].AnswerId == a.Id))
                                        }).every((an) => an == true))


                                       this.props.PostPlayStatistic({
                                           QuestionId: this.props.Question.Question.Id,
                                           Key: this.props.Key,
                                           Player: this.props.Player,
                                           Correct: Correct,
                                           TotalTime: Math.trunc(0.001 * ((new Date()).getTime() - this.state.StartTime)),

                                           Score: this.state.AnswersImage.map((a,i) => {
                                            return( a && (this.props.Question.Question.ClickImages[i].AnswerId == a.Id))
                                        }).filter(a => a).length
                                        + 
                                        this.state.AnswersChart.map((a,i) => {
                                            return( a && (this.props.Question.Question.ClickCharts[i].AnswerId == a.Id))
                                        }).filter(a => a).length + '/ ' + (this.state.AnswersImage.length + this.state.AnswersChart.length)
                                       })
                                    }}
                                    >
                                        Check Answer
                                    </Badge>
                                </h3>
                            </Col>
                            : <div/>}
                             {this.state.ShowAnswer && this.props.Object && this.props.InSeries? 
                                <Col xs = {2}>
                                <h3>
                                    <Badge color = "primary"
                                    style = {{cursor:'pointer'}}
                                    onClick = {() => {
                                        

                                        if(this.props.Object.state.QuestionsAnswers.filter(a => !a.Answered).length )
                                        {
                                            this.props.Object.setState({
                                                CurrentIndex: this.props.Object.state.CurrentIndex + 1
                                            })
    
                                            return
                                        }
    
                                        this.props.Object.setState({
                                            ShowFinalScores: true
                                        })

                                        this.setState({
                                            ShowAnswer: false,
                                            AnswersImage:[],
                                            AnswersChart: []
                                        })

                                    }}
                                    >
                                        Next
                                    </Badge>
                                </h3>
                            </Col>
                            : <div/>}
                            {this.state.ShowAnswer ?
                            <Col xs = {2}>
                                <h3>
                                    <Badge color = {'success'}
                                    style = {{cursor:'pointer'}}
                                    onClick = {() => {
                                       this.setState({
                                           ShowSolution: (true && ShowSolutions)
                                       })
                                    }}
                                    >
                                        Show Solution
                                    </Badge>
                                </h3>
                            </Col> : <div/>}
                            {this.state.ShowAnswer && this.props.Question.Question.PDFURL && ShowSolutions ?
                            <Col xs = {2}>
                                <h3>
                                    <Badge color = {'danger'}
                                    style = {{cursor:'pointer'}}
                                    onClick = {() => {
                                        window.open(this.props.Question.Question.PDFURL)  
                                        
                                        let Correct  =(
                                            !this.props.Question.Question.ClickImages.length ||
                                            this.state.AnswersImage.map((a,i) => {
                                            return( a && (this.props.Question.Question.ClickImages[i].AnswerId == a.Id))
                                            }).every((an) => an == true) )
                                            &&
    
                                            (!this.props.Question.Question.ClickCharts.length || this.state.AnswersChart.map((a,i) => {
                                                return( a && (this.props.Question.Question.ClickCharts[i].AnswerId == a.Id))
                                            }).every((an) => an == true))

                                        let data = new FormData()

                                        data.append('QuestionId',this.props.Question.Question.Id)
                                        data.append('Player', this.props.Player)
                                        data.append('Correct', Correct)

                                        this.props.PostPDFStatistic(data)
                                    }}
                                    >
                                        PDF Solution
                                    </Badge>
                                </h3>
                            </Col> : <div/>}
                            {this.state.ShowAnswer && this.props.Question.Question.VIDEOURL  && ShowSolutions?
                            <Col xs = {2}>
                                <h3>
                                    <Badge color = {'primary'}
                                    style = {{cursor:'pointer'}}
                                    onClick = {() => {
                                        window.open(this.props.Question.Question.VIDEOURL)  
                                    }}
                                    >
                                        Video Solution
                                    </Badge>
                                </h3>
                            </Col> : <div/>}
                            
                        </Row>
                        <br/>
                        {this.state.ShowAnswer ?
                        <Row style = {{border:1, borderStyle:'solid', borderColor:'#cccccc', width:250, marginLeft:20}}>
                            <Col xs = {6}>
                                <NameComponent text = {'Score'} textColor={'#595959'}/>
                            </Col>
                            <Col xs = {2}>
                                <NameComponent text = {this.state.AnswerStatesImages.filter(a => a).length + this.state.AnswerStatesCharts.filter(a => a).length} textColor={'#0099cc'}/>
                            </Col>
                            <Col xs = {3}>
                                <NameComponent text = {'/ ' + (this.state.AnswersImage.length + this.state.AnswersChart.length)} textColor={'#595959'}/>
                            </Col>
                        </Row> : <div/>}
                      
                        
                  </div>
                  }
            </div>
        )
    }

    ImageModal(){
        if(!(this.props.Question && this.props.Question.ImageAnswerGroups && this.state.SelectedImage.AnswerGroupId)){
            return
        }

        return(
            <ModalComponent isOpen = {this.state.ShowImageModal} size = {"xl"} NoActionLog = {true}>
            {this.state.FLImageAnswer == null
            ?<Row  style = {{marginLeft: 10, overflowX:'scroll', width:'100%'}}>
                    {this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0].Images.map((image, image_index) => (
                        <Col xs = {2} style = {{flexDirection:'column', alignItems:'center', alignContent:'center', cursor:'pointer', 
                        marginRight:10,
                         borderWidth:image_index == this.state.FLImageAnswer ? 2 : 1,
                         borderStyle:'dashed',
                         borderColor:image_index == this.state.FLImageAnswer ? 'green' : '#b3b3b3'}}
                        onClick = {() => {
                            if(this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0]
                            .Images[image_index]
                            .Leafs.length){
                                this.setState({
                                    FLImageAnswer:image_index,
                                    SLImageAnswer: -1
                                    })
                            }
                            else{
                                let AnswersImage = this.state.AnswersImage

                                AnswersImage[this.state.SelectedImageIndex] 
                                = this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0]
                                .Images[image_index]
                                
        
                                this.setState({
                                    ShowImageModal: false,
                                    AnswersImage: AnswersImage
                                })
                            }
                           
                        }}
                        >
                            <ImageTreeNode
                                    Data = {[image.Name]} Image = {image.URL} 
                                    ClickTexts = {[]}
                                    ClickColors = {[]}
                                    OnClicks = {[]}
                                        />
                                </Col>
                    ))
                    
                    }
                
            </Row> : <div/>}
            {this.state.FLImageAnswer != null 
                ?
                <Row  style = {{marginLeft: 10, overflowX:'scroll', width:'100%'}}>
                        {this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0].Images[this.state.FLImageAnswer].Leafs
                        .sort((a, b) => (a.Id  > b.Id) ? 1 : -1).map((image, image_index) => (
                            <Col xs = {2}  style = {{flexDirection:'column', alignItems:'center', alignContent:'center', cursor:'pointer', 
                            marginRight:20, marginBottom:10,
                             borderWidth:image_index == this.state.SLImageAnswer ? 2 : 1,
                             borderStyle:'dashed',
                             borderColor:image_index == this.state.SLImageAnswer ? 'green' : '#b3b3b3', width:160}}
                            onClick = {() => {
                                let AnswersImage = this.state.AnswersImage

                                AnswersImage[this.state.SelectedImageIndex] 
                                = this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0]
                                .Images[this.state.FLImageAnswer]
                                .Leafs[image_index]
        
                                this.setState({
                                    ShowImageModal: false,
                                    AnswersImage: AnswersImage
                                })

                                //this.setState({SLImageAnswer:image_index})
                            
                            }}
                            >
                                <ImageTreeNode
                                        Data = {[image.Name]} Image = {image.URL} 
                                        ClickTexts = {[]}
                                        ClickColors = {[]}
                                        OnClicks = {[]}
                                            />
                                    </Col>
                        ))
                        
                        }
                    
                    {/*<Col xs = {3} style = {{marginLeft: 10, overflowY:'scroll', height:220, width:'100%'}}>
                        {this.state.FLImageAnswer != null ? 
                        this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0].Images[this.state.FLImageAnswer].Leafs.map((image, image_index) => (
                            <div style = {{flexDirection:'column', alignItems:'center', alignContent:'center', cursor:'pointer', 
                            marginRight:20, marginBottom:10,
                             borderWidth:image_index == this.state.SLImageAnswer ? 2 : 1,
                             borderStyle:'dashed',
                             borderColor:image_index == this.state.SLImageAnswer ? 'green' : '#b3b3b3', width:160}}
                            onClick = {() => this.setState({SLImageAnswer:image_index})}
                            >
                                <ImageTreeNode 
                                        Data = {[image.Name]} Image = {image.URL} 
                                        ClickTexts = {[]}
                                        ClickColors = {[]}
                                        OnClicks = {[]}
                                            />
                                    </div>
                        ))
                        
                        : <div/>}
                    </Col>*/}
                </Row> : <div/>}
            <br/>
            {/*<Col xs = {3} style = {{margin:10,
                            border:1, borderStyle:'solid',  borderColor:'#0099cc', borderRadius:20,
                            flexDirection:'column',display:'flex', alignItems:'center', alignContent:'center',}}
                                
                            >
                                <div style = {{ flexDirection:'column',display:'flex', alignItems:'center', alignContent:'center', width: '100%'}}>
                                    <h5 style = {{color: 'black', textAlign:'center', alignSelf:'center',  width:'101%', borderRadius:20}}>
                                        Selected Answer
                                    </h5>
                                </div>
            </Col>
            <Row>
                <Col xs = {3} style = {{marginLeft: 10, height:220, width:'100%'}}>
                    {this.state.FLImageAnswer != null? 
                    
                        <div style = {{flexDirection:'column', alignItems:'center', alignContent:'center', 
                        marginRight:20, marginBottom:10,
                         borderWidth:1,
                         borderStyle:'dashed',
                         borderColor: 'green', width:160}}
                        >
                            <ImageTreeNode 
                                    Data = {[this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0].Images[this.state.FLImageAnswer].Name]}
                                    Image = {this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0].Images[this.state.FLImageAnswer].URL} 
                                    ClickTexts = {[]}
                                    ClickColors = {[]}
                                    OnClicks = {[]}
                                        />
                                </div>
                    
                    : <div/>}
                </Col>
                <Col xs = {3} style = {{marginLeft: 10, height:220, width:'100%'}}>
                {this.state.FLImageAnswer != null 
                && (this.state.SLImageAnswer != null && this.state.SLImageAnswer != -1) 
                ? 
                    
                    <div style = {{flexDirection:'column', alignItems:'center', alignContent:'center', 
                    marginRight:20, marginBottom:10,
                     borderWidth:1,
                     borderStyle:'dashed',
                     borderColor: 'green', width:160}}
                    >
                        <ImageTreeNode 
                                Data = {[
                                    this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0]
                                    .Images[this.state.FLImageAnswer]
                                    .Leafs[this.state.SLImageAnswer].Name
                                ]}

                                Image = {
                                    this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0]
                                    .Images[this.state.FLImageAnswer]
                                    .Leafs[this.state.SLImageAnswer].URL
                                }

                                ClickTexts = {[]}
                                ClickColors = {[]}
                                OnClicks = {[]}
                                    />
                            </div>
                
                : <div/>}
                </Col>
            </Row>*/}
            {/*<hr/>
            <Row>
                <Col xs = {7}>
                    
                </Col>
                <Col xs = {2}>
                    <h3 style = {{cursor:'pointer'}} onClick = {(e) => {

                        if(this.state.SLImageAnswer == null || this.state.SLImageAnswer == -1)
                        {
                            alert('choose image please')

                            return
                        }

                        let AnswersImage = this.state.AnswersImage

                        AnswersImage[this.state.SelectedImageIndex] = this.props.Question.ImageAnswerGroups.filter((g) => g.Id == this.state.SelectedImage.AnswerGroupId)[0]
                        .Images[this.state.FLImageAnswer]
                        .Leafs[this.state.SLImageAnswer]

                        this.setState({
                            ShowImageModal: false,
                            AnswersImage: AnswersImage
                        })
                    }}>
                        <Badge color = "success">
                            Choose
                        </Badge>
                    </h3>
                </Col>
                <Col xs = {2}>
                    <h3 style = {{cursor:'pointer'}} onClick = {(e) => this.setState({ShowImageModal: false})}>
                        <Badge color = "danger">
                            Close
                        </Badge>
                    </h3>
                </Col>
            </Row>*/}
            </ModalComponent>
        )
    }

    ChartModal(){
        if(this.state.SelectedChartIndex == null){
            return
        }

        return(
            <Modal isOpen = {this.state.ShowChartModal} size = "lg">
            <ModalBody>
           <div style = {{flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center', width:'100%'}}>
                <ChartModalSliders
                style = {{width:600, height:400}}
                Father = {this}
                />
            </div>
            
            </ModalBody>
            <ModalFooter>
                <Button color="success" onClick = {() => this.calculateChartFromSliders()}>
                        Choose
                </Button>
                <Button color="danger" onClick = {() => this.setState({ShowChartModal: false})}>
                        Close
                </Button>
            </ModalFooter>
            
            </Modal>
        )
    }


    calculateChartFromSliders(){
        console.log(this)

        const {SlidersValues} = this.state
        const {InterpretationValues} = this.props
        
        const LeftValues = InterpretationValues.Left
        const RightValues = InterpretationValues.Right
        const RatioValues = InterpretationValues.RatioOfGradients
        const JumpValues = InterpretationValues.Jump

        //Calculate gradients and jump
        const LeftGradient = (SlidersValues[1] - SlidersValues[0]) 
        const RightGradient = (SlidersValues[2])
        const RatioOfGradients = Math.abs(LeftGradient) - Math.abs(RightGradient)
       
        let _Jump =  "NO JUMP"

        if(SlidersValues[1] > 0) _Jump = ">";
        if(SlidersValues[1] < 0) _Jump = "<";

        const Jump = _Jump

        console.log("LeftGradient="+LeftGradient)
        console.log("RightGradient="+RightGradient)
        console.log("RatioOfGradients="+RatioOfGradients)
        console.log("Jump="+Jump)
        console.log("SlidersValues="+SlidersValues)
        
        //Get interpertation object Ids
        //Left
        const LeftInterpretationValue = (LeftValues).filter(v => {

            if(LeftGradient == 0) return (v.Value == "Zero");

            if(LeftGradient > 0) return (v.Value == "+");

            return (v.Value == "-");

        })[0]

        const LeftId = LeftInterpretationValue.Id

        //Right
        const RightInterpretationValue = (RightValues).filter(v => {

            if(RightGradient == 0) return (v.Value == "Zero");

            if(RightGradient > 0) return (v.Value == "+");

            return (v.Value == "-");

        })[0]

        const RightId = RightInterpretationValue.Id

        //Ratio
        const RatioInterpretationValue = (RatioValues)
        .filter(v => {

            if(Math.abs(RatioOfGradients) < 0.05) return (v.Value == "=");

            if(RatioOfGradients > 1) return (v.Value == ">");

            return (v.Value == "<");

        })[0]

        const RatioId = RatioInterpretationValue.Id

        //Jump
        const JumpInterpretationValue = (JumpValues).filter(v => {
        return (v.Value == Jump)
        })[0]

        const JumpId = JumpInterpretationValue.Id        
        
        //Get Image
        const Image = this.state.SelectedChart.AnswerGroup.Images
        .filter(i => (i.LeftId == LeftId 
                        && i.RightId == RightId 
                        && i.JumpId == JumpId 
                        && i.RationOfGradientsId == RatioId))[0]

        const textAnswer = LeftInterpretationValue.Value + "," + RightInterpretationValue.Value + "," + JumpInterpretationValue.Value + "," + RatioInterpretationValue.Value
        
        let AnswersChart = this.state.AnswersChart

        AnswersChart[this.state.SelectedChartIndex] = {
            ...Image,
            AnswerText:textAnswer
        }

        this.setState({
            ShowChartModal: false, 
            AnswersChart: AnswersChart
        })
    }
}

//Constant
//
const QUESTION_SEARCHING_PARAMETER = 'IsQuestionSearching'

const QUESTION_DATA_PARAMETER = 'Question'

const QUESTION_GET_ERROR_PARAMETER = 'QuestionGetError'
//
const IVALUES_SEARCHING_PARAMETER = 'IsIIValuesSearching'
const IVALUES_DATA_PARAMETER = 'IIValues'
const IVALUES_GET_ERROR_PARAMETER = 'IIValuesGetError'
//
const QUESTION_STATISTIC_IS_ADDING_PARAMETER = 'QuestionStatisticIsAdding'
const QUESTION_STATISTIC_ERROR_ADD_PARAMETER = 'QuestionStatisticAddError'


function MapStateToProps(state) {
    return {

        IsQuestionSearching: state.Query[QUESTION_SEARCHING_PARAMETER],
        Question: state.Query[QUESTION_DATA_PARAMETER],
        GetQuestionError: state.Query[QUESTION_GET_ERROR_PARAMETER],
        Name: state.Authorization.name,
        Player: state.Authorization.student_key,

        InterpretationValues:state.Query[IVALUES_DATA_PARAMETER],
        IsValuesSearching: state.Query[IVALUES_SEARCHING_PARAMETER],
    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        GetInfo: (Id) => {dispatch(GetMultipleListAttempt_ACTION([
            {
                SearchParameter: IVALUES_SEARCHING_PARAMETER,
                DataParameter: IVALUES_DATA_PARAMETER,
                GetErrorParameter: IVALUES_GET_ERROR_PARAMETER,
    
                Path: Routes.GetInterpretationValues,
    
                [IVALUES_SEARCHING_PARAMETER]: true,
                [IVALUES_DATA_PARAMETER]: [],
                [IVALUES_GET_ERROR_PARAMETER]: '',
            },
            {
                SearchParameter: QUESTION_SEARCHING_PARAMETER,
                DataParameter: QUESTION_DATA_PARAMETER,
                GetErrorParameter: QUESTION_GET_ERROR_PARAMETER,
                Path: Routes.GetQuestionClickablePlay,
    
                Value: Id,
    
                [QUESTION_SEARCHING_PARAMETER]: true,
                
                [QUESTION_DATA_PARAMETER]: {},
        
                [QUESTION_GET_ERROR_PARAMETER]: ''
            }
        ]))},
        GetQuestion: (Id) => {dispatch(GetListAttempt_ACTION({
            SearchParameter: QUESTION_SEARCHING_PARAMETER,
            DataParameter: QUESTION_DATA_PARAMETER,
            GetErrorParameter: QUESTION_GET_ERROR_PARAMETER,
            Path: Routes.GetQuestionClickablePlay,

            Value: Id,

            [QUESTION_SEARCHING_PARAMETER]: true,
            
            [QUESTION_DATA_PARAMETER]: {},
    
            [QUESTION_GET_ERROR_PARAMETER]: ''
        }))},
        PostPlayStatistic: (Statistic) => {dispatch(AddObjectAttempt_ACTION({
            AddParameter: QUESTION_STATISTIC_IS_ADDING_PARAMETER,
            AddErrorParameter: QUESTION_STATISTIC_ERROR_ADD_PARAMETER,

            AddPath: Routes.PostStatistic,

            [QUESTION_STATISTIC_IS_ADDING_PARAMETER]: true,
            [QUESTION_STATISTIC_ERROR_ADD_PARAMETER]: '',
            Body:{
                ...Statistic
            }
        }))},
        PostPDFStatistic: (Statistic) => {dispatch(AddFileAttempt_ACTION({
            AddParameter: QUESTION_STATISTIC_IS_ADDING_PARAMETER,
            AddErrorParameter: QUESTION_STATISTIC_ERROR_ADD_PARAMETER,

            AddPath: Routes.AddQuestionPDFStatistic,

            [QUESTION_STATISTIC_IS_ADDING_PARAMETER]: true,
            [QUESTION_STATISTIC_ERROR_ADD_PARAMETER]: '',
            Body:Statistic
        }))}
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(ClickableQuestionPlayComponent)